var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormInputContainer',{staticClass:"FormDateInput",attrs:{"inputId":`I${_vm._uid}`,"label":_vm.label,"errors":_vm.errors}},[_c('FlatPickr',_vm._b({attrs:{"id":`I${_vm._uid}`,"value":_vm.value,"config":_vm.config},on:{"on-change":_vm.handleChange}},'FlatPickr',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }